import React from 'react'
import { ChoicesColContainer, Container, QuestionContainer, QuestionsWrapper } from './style'
import { SingleQuestionCol } from '../../../../../components/Questionnaire/SingleQuestion'

interface ChoicesProps {
  label: string
  choices: any
}
const Choices: React.FC<ChoicesProps> = ({ label, choices }) => {
  return (
    <ChoicesColContainer>
      <h3>{`${label}`}</h3>
      {choices.map((choice: any, index: number) => {
        console.log(choice, index);
        return (
          <div key={`choice_${index}`} onClick={(e) => {
            e.stopPropagation();
          }}>
            <input
              type="radio"
              value={choice.title}
              name={`radios_question_${index}`}
              checked={choice.selected}
            />
            <label>{choice.title}</label>
          </div>
        )
      })}
    </ChoicesColContainer>
  )
}

const FoodIntakeAndDigestionResult = () => {
  const yesNo = [
    { title: 'Yes' },
    { title: 'No' },
  ]
  return (
    <Container>
      <h2>Food Intake and Digestion</h2>
      <p>
        <u><strong>Your food</strong></u>
      </p>
      <QuestionsWrapper>
        <QuestionContainer>
          <label>I am vegetarian</label>
          <Choices
            label=''
            choices={yesNo}
          />
        </QuestionContainer>
        <QuestionContainer>
          <label>I am vegetarian</label>
        </QuestionContainer>
      </QuestionsWrapper>
    </Container>
  )
}

export default FoodIntakeAndDigestionResult